/** Static promotional strip above the header -- no backend, copy only. Kept as its own component so it's trivial to swap for a CMS-driven banner later without touching SiteHeader. */
export function AnnouncementBar() {
  return (
    <div className="bg-brand text-brand-foreground px-4 py-2 text-center text-xs font-semibold sm:text-sm">
      Free delivery on orders above ₹499 · Delivered in under 60 minutes
    </div>
  );
}
